class FreeSampleAccordion {
  constructor() {
    this.init();
  }

  init() {
    const accordionHeaders = document.querySelectorAll('.free-sample-detail__accordion-header');

    accordionHeaders.forEach(header => {
      header.addEventListener('click', () => {
        this.toggleAccordion(header);
      });
    });
  }

  toggleAccordion(header) {
    const accordion = header.closest('.free-sample-detail__accordion');
    const content = accordion.querySelector('.free-sample-detail__accordion-content');
    const isActive = header.classList.contains('active');

    if (isActive) {
      // Kapat
      header.classList.remove('active');
      content.classList.remove('active');
    } else {
      // Aç
      header.classList.add('active');
      content.classList.add('active');
    }
  }
}

class FreeSampleFilter {
  constructor() {
    this.init();
  }

  init() {
    // Filter link'lerine event listener ekle
    const filterLinks = document.querySelectorAll('.free-sample-filter__item-link');

    filterLinks.forEach(link => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.handleFilterClick(link);
      });
    });

    // İlk yüklemede ilk item'ı aktif yap
    this.initializeFirstItem();
  }
 
  handleFilterClick(clickedLink) {
    const dataId = clickedLink.getAttribute('data-id');

    // Tüm filter item'lardan active class'ını kaldır
    const allFilterItems = document.querySelectorAll('.free-sample-filter__item');
    allFilterItems.forEach(item => {
      item.classList.remove('active');
    });

    // Tıklanan item'ın parent'ına active class'ı ekle
    const clickedItem = clickedLink.closest('.free-sample-filter__item');
    clickedItem.classList.add('active');

    // Tüm content'lere hidden class'ı ekle
    const allContents = document.querySelectorAll('.free-sample-filter__content');
    allContents.forEach(content => {
      content.classList.add('hidden');
    });

    // İlgili content'den hidden class'ını kaldır
    const targetContent = document.querySelector(`.free-sample-filter__content[data-id="${dataId}"]`);
    if (targetContent) {
      targetContent.classList.remove('hidden');
    }
  }

  initializeFirstItem() {
    const firstFilterItem = document.querySelector('.free-sample-filter__item');
    const firstFilterContent = document.querySelector('.free-sample-filter__content');

    if (firstFilterItem) {
      firstFilterItem.classList.add('active');
    }

    if (firstFilterContent) {
      firstFilterContent.classList.remove('hidden');
    }
  }
}

// DOM yüklendiğinde accordion ve filter'ı başlat
document.addEventListener('DOMContentLoaded', () => {
  new FreeSampleAccordion();
  new FreeSampleFilter();
});
